import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Translate from '../../../utils/Translate';
import Header from '../../commons/Header/Header';
import ProfileSummary from './ProfileSummary/ProfileSummary';
import SocialNetworkSummary from './CommunicationsSummary/SocialNetworkSummary';
import TravelCompanionSummary from './TravelCompanionSummary/TravelCompanionSummary';
import CreditCardsSummary from './CreditCardsSummary/CreditCardsSummary';
import BillingSummary from './BillingSummary/BillingSummary';
import './ProfilePage.css';
import TopicTracker from '../../../tracking/TopicTracker';
import ActiveSessionsSummary from './ActiveSessionsSummary/ActiveSessionsSummary';
import Alert from '../../commons/Alert/Alert';
import AccountPreferencesSummary from './AccountPreferencesSummary/AccountPreferencesSummary';
import DomUtils from '../../../utils/DomUtils';
import { trackingEvents } from '../../../tracking/trackingData';
import *  as Pages from '../../../utils/Pages';
import {Feature} from '../../../services/enums/Feature';

@withRouter
class ProfilePage extends React.Component {
  constructor(props) {
    super(props);
    this.headerNode = React.createRef();
  }

  componentDidMount() {
    if (this.props.profile.visited) {
      this.props.profile.visited = false;
      TopicTracker.access(trackingEvents.PERSONAL_INFO);
    }
    if (this.props.location.pathname.endsWith('/account')) {
      DomUtils.scroll(this.headerNode, 'start');
    }
  }

  render() {
    return (
      <div className="eva-3-dashboard-aftersale ProfilePage -eva-3-bc-gray-4">
        <div ref={(headerNode) => { this.headerNode = headerNode; }} >
          <Header page={Pages.PROFILE}/>
        </div>

        <div className="eva-3-container -eva-3-bc-gray-4 -p-0 -p-md-2 -pb-md-4 -pl-md-5 -pr-md-5 -pt-4">
          <div className="dashboard-aftersale-results-container eva-3-row -no-gutter">
            {
              this.props.isMerging &&
              <div className="col -sm-12 -lg-8 -eva-3-mb-lg">
                <Alert type="warning" title={Translate.message('Estamos uniendo tus cuentas')}>
                  {Translate.message('Mientras se realiza el proceso, no podrás modificar los datos de tu perfil. Por favor, regresá más tarde.')}
                </Alert>
              </div>
            }
            <div className="col -sm-12 -lg-8">
              <ProfileSummary
                user={this.props.profile.personalInfoStore}
                loyalty={this.props.profile.loyaltyStore}
                clustersErrors={this.props.clustersErrors}
              />
            </div>
            <div className="col -sm-12 -lg-8">
              {
                this.props.profile.personalInfoStore.isBillingProfilesSectionAvailable === false && (
                  <div className="eva-3-row -no-gutter -eva-3-mt-lg -divided-md ">
                    <div className="col -sm-12 -md-6 -eva-3-bc-white -mr-md-1 -p-2 -p-md-4 -pt-md-3 -pb-md-3 -mb-md-0">
                      <CreditCardsSummary
                        isMerging={this.props.isMerging}
                        className="-mr-md-2"
                        creditCards={this.props.profile.creditCardsStore}
                        hasError={this.props.clustersErrors.creditCards}
                      />
                    </div>
                    <div className="col -sm-12 -md-6 -p-md-4" />
                  </div>
                )
              }
              {
                this.props.profile.personalInfoStore.isBillingProfilesSectionAvailable !== false && (
                  <div
                    className="eva-3-row -no-gutter -eva-3-mt-lg -eva-3-bc-white -pt-md-3 -pt-2 -pb-3 -pl-2 -pr-2 -pl-md-4 -pr-md-4"
                  >
                    <div className="col -sm-12 -md-6 -pr-md-4">
                      <CreditCardsSummary
                        isMerging={this.props.isMerging}
                        className="-mr-md-2"
                        creditCards={this.props.profile.creditCardsStore}
                        hasError={this.props.clustersErrors.creditCards}
                      />
                    </div>
                    <div className="col -sm-12 -md-6 -mt-2 -mt-md-0 -pl-md-4">
                      <BillingSummary
                        isMerging={this.props.isMerging}
                        className="-ml-md-2"
                        billingProfiles={this.props.profile.billingProfilesStore}
                        hasError={this.props.clustersErrors.billingProfiles}
                      />
                    </div>
                  </div>
                )
              }
            </div>
            <div className="col -sm-12 -lg-8">
              <div className="eva-3-row -no-gutter -eva-3-mt-lg -divided-md ">
                <div
                  className="col -sm-12 -md-6 -eva-3-bc-white -mr-md-2 -p-2 -p-md-4 -pt-md-3 -pb-md-3  -mb-3 -mb-md-0"
                >
                  <TravelCompanionSummary
                    isMerging={this.props.isMerging}
                    travelCompanions={this.props.profile.travelCompanionsStore}
                    hasError={this.props.clustersErrors.travelCompanions}
                  />
                </div>

                <SocialNetworkSummary
                  isMerging={this.props.isMerging}
                  settings={this.props.profile.communicationSettingsStore}
                  hasError={this.props.clustersErrors.communicationPreferences}
                />
              </div>
            </div>
            <div className="col -sm-12 -lg-8">
              <div className="eva-3-row -no-gutter -eva-3-mt-lg -divided-md ">
                <div className="col -sm-12 -md -6 -eva-3-bc-white -mr-md-2 -p-2 -p-md-4 -pt-md-3 -pb-md-3  -mb-3 -mb-md-0 ">
                  <ActiveSessionsSummary
                    isMerging={this.props.isMerging}
                    activeSessions={this.props.profile.activeSessionPageStore.activeSessions}
                    hasError={this.props.clustersErrors.activeSessions}
                  />
                </div>
                <div className="col -sm-12 -md-6 -eva-3-bc-white -ml-md-2 -p-2 -p-md-4 -pt-md-3 -pb-md-3 -mb-3 -mb-md-0">
                  <AccountPreferencesSummary isWhiteLabel={this.props.isWhiteLabel} isFeatureEnabled={Array.isArray(this.props.whiteLabelFeatures) && this.props.whiteLabelFeatures.includes(Feature.PRICE_ALERTS)} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProfilePage.defaultProps = {
  location: undefined,
};

ProfilePage.propTypes = {
  profile: PropTypes.shape().isRequired,
  clustersErrors: PropTypes.shape().isRequired,
  location: PropTypes.shape(),
  isMerging: PropTypes.bool.isRequired,
  isWhiteLabel: PropTypes.bool.isRequired,
  whiteLabelFeatures: PropTypes.arrayOf(PropTypes.string),
};

export default ProfilePage;
